import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const novemberMap: Array<IPixelMapDay> = [
	{
		status: "average",
		icon: "theaters",
		title: "Midfest Moviefest",
		reason: `
			Today was a Friday but I had no work today since it was a holiday, All Saints' Day. I honestly didn't have anything else to do today but I wanted to take my new phone out for a spin. In the morning, I went back to reserving tickets for House of Sayuri (2024) again and I saw that there were seats for it. It was only 150 Pesos so it didn't cost me much. Since it was cheap, I also booked another movie which was for Tenement (2024). I booked it because the trailer was kind of creepy enough.

			Eventually, I went to SM Aura to watch both movies and, honestly, both were mid. Tenement was too boring, it barely had a plot and didn't connect the characters that well. It also lacked a good plot. House of Sayuri gave me an intense whiplash when the grandmother suddenly went "super saiyan" and got powers. House of Sayuri was "alright" as a movie by itself, it was definitely something I've never seen in a movie, but I didn't like either film on the grounds that I just wanted to be scared. It was pretty disappointing, to be honest, and I did nothing more than think about how I lost someone. In the evening, I just went home and ordered takeout for my sister and I.
		`,
		spotify: {
			artist: "Jonathan Groff",
			album: "Hamilton (Original Broadway Cast Recording)",
			song: "You'll Be Back",
			link: "https://open.spotify.com/track/6OG1S805gIrH5nAQbEOPY3?si=fc873a115b0641ae"
		},
		resonatedLyrics: [
			"Remember, despite our estrangement, I'm your man",
			"You'll be back, soon you'll see",
			"You'll remember you belong to me",
			"You'll be back, time will tell",
			"You'll remember that I served you well",
			"Oceans rise, empires fall",
			"We have seen each other through it all",
			"And when push comes to shove",
			"I will send a fully armed battalion to remind you of my love!",
			"",
			"Da da da dat da dat da da da da ya da",
			"Da da dat dat da ya da!",
			"Da da da dat da dat da da da da ya da",
			"Da da dat dat da",
		],
	},
	{
		status: "above-average",
		reason: `
			In the morning, I went outside with my sister so we could get my blood work done, as requested by my mom. But unfortunately, they weren't taking in blood samples anymore so we just went grocery shopping for a few items. I bought Paotsin, which I haven't eaten in a long time. We went to another place that had some blood tests but they told me that I was already over fasting, so we had to push it to tomorrow. We just got food and then went home.

			We had a lot of food to eat and the Paotsin really made me full. The night was pretty chill after that and nothing much happened.
		`,
		spotify: {
			artist: "ILLIT",
			album: "SUPER REAL ME",
			song: "Midnight Fiction",
			link: "https://open.spotify.com/track/6QqrxJe1iQxwLY6he6FLFo?si=356ff14cc9d34733"
		}
	},
	{
		status: "average",
		reason: `
			I woke up really early to get my blood work done. It was painful but the process of getting my bloodwork done was relatively easier than what I had expected. I then went home and passed my day without doing anything noteworthy. I did receive results in the afternoon, which was a surprise. Thankfully, the readings were fairly-normal and I'm without issue aside from a few lifestyle changes which I've been meaning to do anyway.

			Nothing else happened for the evening as I just passed my time.
		`,
		spotify: {
			artist: "Beabadobee",
			album: "Coffee",
			song: "Coffee",
			link: "https://open.spotify.com/track/429NtPmr12aypzFH3FkN9l?si=e8fa20637ac249fc"
		}
	},
	{
		status: "average",
		reason: `
			Nothing much happened today. I tried to be productive and thought that drinking coffee would help that, but it just made me jittery and too hyperactive with no focus. It was also disappointing to see that my Starbucks order did not count as a sticker. Work passed by and the evening came and went with nothing significant happening.
		`,
		spotify: {
			song: "Rather Be (feat. Jess Glynne)",
			album: "Rather Be (feat. Jess Glynne)",
			artist: "Clean Bandit",
			link: "https://open.spotify.com/track/3s4U7OHV7gnj42VV72eSZ6?si=ba93f44724694c60"
		},
	},
	{
		status: "above-average",
		icon: "skillet",
		reason: `
			Today was a pretty boring day so, in the evening, I went outside to BGC and I met up with my sister. We got Starbucks at 32nd Street and I treated her to Samgyupsalamat. We both had fun eating and we took pics. We saw a few music videos on the TV at Samgyupsalamat and we tried some new fizzy drinks. It had rained pretty badly when we were eating and, by the time we finished, it was still waiting pretty hard. We waited a while for the rain to subside and we were able to book a Grab ride home. I just chilled for the evening and nothing else went on after that.
		`,
		spotify: {
			song: "Mirror Mirror",
			album: "Shades of Purple",
			artist: "M2M",
			link: "https://open.spotify.com/track/2gX1J5hbHs1V7gkHsNglTv?si=e6480478d8294aa8"
		},
		resonatedLyrics: [
			"I must be stupid, must be crazy, must be out of my mind",
			"Now in the cold light of the day, I realize",
			"",
			"Mirror, mirror hanging on the wall",
			"You don't have to tell me",
			"Who's the biggest fool of all",
			"Mirror, mirror I wish you could lie to me",
			"And bring my baby back",
			"Bring my baby back to me",
		]
	},
	{
		status: "above-average",
		icon: "movie_info",
		title: "It Takes",
		reason: `
			For today, I mostly just watched the US election go on as the day progressed. I was really surprised at the outcome. Since I was bored, I went out to watch a movie. I watched We Live in Time (2024) at Venice Grand Canal and it was pretty good. Some parts of it were pretty emotional, although I somehow got confused by the flow of the story. But it was good and it eventually ended.

			Since I still had time, I asked Loy if he was still down to meet. Since I was just nearby, I offered to visit him at his house like we used to. I booked a ride there and eventually arrived. We mostly talked about a few stuff, he showed me his Steam Deck again and I played Thrillville: Off the Rails on it for a while. We also ate some luncheon meat he cooked up. He mostly talked about his current situation, and I just tried my best to listen and give him advice on it. After that, it was already starting to get late so I booked an Angkas ride and eventually went home.

			I just realized that it took that many things happening in the day for me to feel okay or count it as "above average" as opposed to before.
		`,
		spotify: {
			song: "Mirror Mirror",
			album: "Shades of Purple",
			artist: "M2M",
			link: "https://open.spotify.com/track/2gX1J5hbHs1V7gkHsNglTv?si=e6480478d8294aa8"
		},
	},
	{
		status: "average",
		reason: `
			Today was filled with anticipation and a kind of "wait" for things. It was as if I had *something* to do today or something had to happen, but apparently nothing like that happened.
		`,
		spotify: {
			song: "Pasensya Ka Na",
			album: "Langit. Luha.",
			artist: "Silent Sanctuary",
			link: "https://open.spotify.com/track/4yrphG2212kF0aIt3qOt3g?si=7e651623008c4628"
		},
	},
	{
		status: "good",
		title: "Meeting Tanya Markova!!!!",
		icon: "theater_comedy",
		reason: `
			My Friday seemed pretty average at first. Nothing much went on for the morning and afternoon. After work, I played Phasmophobia with Rachel and we just talked and I was able to rant to her about some things. It was nice and my sister and I ordered Greenwich for dinner. I got lasagna and was enjoying it.

			All of a sudden, my sister saw that one of our favorite bands, Tanya Markova, was playing tonight at Social House Bar and Restaurant around Circuit Makati. At first, she was apprehensive to go, but since I had no plans with anyone else tonight, I decided to just force my sister into going through meeting them. We both got ready and our Angkas rides actually arrived at the same time. We both kept seeing each other and passing by one another on the way there. It was pretty cool. My sister got there first and she actually arrived near the bar itself, while I was dropped off at the front of the mall. I eventually met up with her and we got 2 tickets inside.

			We watched a lot of artists and bands perform that night. It was pretty good, in my opinion. I have never been to a music gig event inside a bar before, despite the many times where I actually attended music gigs. It was a new experience for me to be able to sit down, eat, and watch artists perform live. It was pretty good. One artist even stood up on a bar table and it was pretty entertaining. I also brought my own power bank and my sister was surprised to know that my iPhone has a USB C port.

			At the end of the night, Tanya Markova played and my night continued from there.
		`,
		spotify: {
			song: "Disney Reprise",
			album: "Tanya Markova",
			artist: "Tanya Markova",
			link: "https://open.spotify.com/track/4aup6xJ0Hmhd0HLKpGBMia?si=c2b2803ad17e4d1b"
		},
	},
	{
		status: "above-average",
		reason: `
			My Saturday began with me and my sister still being in the bar gig from yesterday and listening to Tanya Markova's songs since they were the last performer. The lead singer even went to my sister and handed her the mic, which seemed pretty surreal. It's too bad I didn't take a proper photo of it. We enjoyed their songs and they eventually ended on Disney. After that, we booked a Grab ride home and I was able to charge and upload pics during the trip home.

			The rest of my Saturday passed by pretty quickly. I woke up late, at around 12 p.m. or so, and thought that I had wasted half of Saturday already. In the evening, I had fun playing Valorant with Rachel. We talked about our current life circumstances and I told them that I still wasn't feeling okay. It was fun to be able to talk and play with a friend again.
		`,
		spotify: {
			song: "Cupid - Twin Ver.",
			artist: "FIFTY FIFTY",
			link: "https://open.spotify.com/track/3Kw7zkALCVxY4wmlnh2IWC?si=56f9c55cc7aa4005",
			album: "The Beginning: Cupid"
		},
		resonatedLyrics: [
			"Now I'm so lonely (Lonely)",
			"Oh, I wish I'd find a lover that could hold me (Hold me)",
			"Now I'm crying in my room",
		]
	},
	{
		status: "special",
		icon: "cognition",
		title: "Going Bald",
		reason: `
			I made a conscious decision today to go bald and have all of my hair shaved off. I just had to let go of it. It symbolized a lot of my anxieties, fears, and self-doubts. I also wanted to let go of it since I'm going to a point in my life where I need to get things together. I felt different after shaving it all off and I also found out that I had psoriasis on my scalp. Maybe going fully bald was the best option after all.

			In the evening, I told Max and Meryll about it. I also deleted a profile that I had and vowed to not meet any more people for now until I get my act together. I'm not going to get into relationships with anyone either.
		`,
		spotify: {
			song: "Thinking Of You",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/4ciwlQ4UYHUMj2wuH0ffw6?si=06343ed74a884681",
			album: "One Of The Boys"
		},
	},
	{
		status: "average",
		reason: `
			Today was a pretty average day, nothing much happened but for a time, I was playing SSX Tricky while someone was talking to me via call. It made me feel horrible afterward because I missed that point in my life. In the evening, I finally watched Oppenheimer (2023) and it was okay. I was surprised by a lot of the familiar faces in the movie. Aside from that, nothing else interesting went on.
		`,
		spotify: {
			artist: "Bruno Major",
			song: "Regent's Park",
			link: "https://open.spotify.com/track/2qiDXgq5fL1FetkhX5xi9L?si=66ba7e955b4f4b82",
			album: "To Let A Good Thing Die"
		}
	},
	{
		status: "average",
		spotify: {
			song: "Sour Grapes",
			artist: "LE SSERAFIM",
			link: "https://open.spotify.com/track/6wBpO4Xc4YgShnENGSFA1M?si=935545a899834f75",
			album: "FEARLESS"
		}
	},
	{
		status: "average",
		icon: "apartment",
		title: "Work Together Alone Again!",
		reason: `
			My company has their "Work ToGather" event again and it's being held at the same place as before in Mega Tower. I got ready to leave after working for a bit and then went there. I was technically late. But by the time I got there anyway, most of my coworkers had just arrived as well.

			The event was okay, I just focused on work and spent the majority of my time sorting out things on Viber. I talked to a few coworkers here and there, but it was nothing noteworthy. I just focused on work throughout the afternoon and we eventually had to go home at around 6 p.m. or so. I had difficulty in finding a ride home so I just chilled at the same spot as last time. What struck me as odd, though, was that I was using an iPhone now instead of some crappy Samsung phone. A few coworkers passed by me and we exchanged glances, but that was mostly it. I eventually got home and ended the night there.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "We Are Never Ever Getting Back Together (Taylor's Version)",
			link: "https://open.spotify.com/track/5YqltLsjdqFtvqE7Nrysvs?si=9807e17579ad455c",
			album: "Red (Taylor's Version)"
		},
		resonatedLyrics: [
			"We (We) are never, ever, ever getting back together",
			"We are never, ever, ever getting back together",
		]
	},
	{
		status: "average",
		reason: `
			Nothing noteworthy happened today aside from me discovering a new song on IG Reels that really resonated with my situation.
		`,
		spotify: {
			artist: "Take That",
			song: "Back for Good - Radio Mix",
			link: "https://open.spotify.com/track/6vcdzohhBSbNdsZBh5IRpQ?si=122967ceb81b4306",
			album: "Nobody Else (Expanded Edition)"
		},
		resonatedLyrics: [
			"Whatever I said, whatever I did I didn't mean it",
			"I just want you back for good",
			"(Want you back, want you back, want you back for good)",
			"Whenever I'm wrong just tell me the song and I'll sing it",
			"You'll be right and understood",
			"(Want you back, want you back, want you back for good)",
			"I want you back for good",
		]
	},
	{
		status: "below-average",
		title: "Owed Controller",
		icon: "sports_esports",
		reason: `
			Today was a really boring day, as usual. My day passed and work just passed by. I had an idea in the afternoon to buy that Dualsense controller I promised someone and I'll also give them back the PS4 disks. I went out and I went to Starbucks, and I tried to find the number of someone's mom. I was able to call her and eventually arrange for her to receive the package.

			Eventually, I bought that brand-new Dualsense controller for someone and even got them a tote bag plus a small Howl-related notepad. I thought about adding a note in there but I just had the controller gift-wrapped. I had a Grab rider pick it up, and then I was able to contact their mom to get it. After she received it, I thought about asking her if she wanted me to get them dinner or something, as a thanks for all the trouble. She laughed at it but eventually declined. I thanked them and went on my way. I did a lot of thinking and walking while in BGC. Someone really didn't contact me, even though I know that their mom gave them the controller. I was kind of half-expecting that they would reach out, but they didn't. Oh well. I just walked to Army Navy to eat a naked sisig burrito and went home after that.
		`,
		spotify: {
			artist: "Miley Cyrus",
			song: "Angels Like You",
			link: "https://open.spotify.com/track/1daDRI9ahBonbWD8YcxOIB?si=011ef4736b104657",
			album: "Plastic Hearts"
		},
		resonatedLyrics: [
			"I know that you're wrong for me",
			"Gonna wish we never met on the day I leave",
			"I brought you down to your knees",
			"'Cause they say that misery loves company",
			"It's not your fault I ruin everything",
		]
	},
	{
		status: "special",
		icon: "ramen_dining",
		title: "Binondo Day!",
		reason: `
			Today was the day I'd go to Binondo with Exavier. We're supposed to leave early today, around 11 a.m. or so, but I just couldn't sleep properly. I ended up falling asleep at 4 a.m. or so.

			I thankfully woke up at the right time, around 10 a.m. and I immediately got ready to go out. I messaged Exavier that I was getting ready and he eventually came over to my house to pass by me. We walked all while talking about various things and then rode a tricycle to the jeep station. I was so scared for my phone because I rode a jeep again and I don't think I've ridden one ever since my Samsung phone got stolen. I tucked my phone in my long sleeve and just watched as we commuted to Pasay. We eventually left the Jeep at around Gateway Mall and rode the LRT going to Manila. We took line 1 of the LRT from EDSA station to Carriedo, with our main destination being Binondo.

			I was still scared for my phone because I feared that it might get stolen, so I still tucked in my phone inside my long sleeves while talking to Exavier. I mainly asked him and his plans for the future. We eventually reach Carriedo station and walked around.

			After that, we went directly to Eng Bee Tin which was supposedly some super-famous store but I'd never heard of it. We passed by a few places that looked extremely Chinese and Binondo seemed so strange but pretty cool. We eventually got to Eng Bee Tin and went inside the store to buy a few snacks and stuff. The line for checkout was actually extremely long, it wrapped around half of the store. We talk about IP addresses, MAC addresses, and other networking things to pass the time. I also took a photo of a big mooncake the store had on display. After we paid for the things, we headed for Lucky Chinatown Mall. Exavier bought something in the grocery section there and I took a photo of a baguette and sent it to Max and Meryll. We then got a reservation at San Guo Lamien and the wait was going to be for a while. We just went to Timezone on an upper floor and Exavier used his Timezone credits to play this Avengers coin game. He actually got a lot of tickets in the process, which seemed impressive tbh. We even had a small crowd of guys gather around us to watch for some reason. But after Exavier stopped playing, we claimed the tickets and went downstairs to the restaurant.
			
			We got inside since it was our turn, but we had to wait for a bit longer until a table opened up. It seems weird that such a successful restaurant would settle for such a small and cramped space inside a mall, but whatever. We finally got our seats and ordered a few things. I got some beef noodles and Exavier got his own dish. Since I was really curious, I tried out the sausage that they were selling. I had never heard of a Chinese sausage dish before so I tried it out of curiosity, I also got dumplings as another side. We waited for a while for our food to arrive, and I noticed that I had bad signal reception all day. Even Exavier's phone had horrible signal. It's honestly so weird that a famous, densely-populated place in Manila itself would lack good signal strength. It just boggled my mind. I also noticed that the table had business cards underneath the glass, cards of different people in different industries. It seemed tacky, maybe they were trying to bank in on any Chinese person wanting to make a deal with them or something. But anyway, we got our food and it honestly made me feel full a few bites in. I barely ate all day and yet I don't have it in me to finish my dish, while Exavier finished his. I had to ask for mine to be taken out and we then left after that was done. Since we were still full and I needed a place to sit so I could transfer money, we went to the UCC Cafe nearby and we got coffee there. Exavier then told me a few things about how much I should focus on my health, be independent and cook my own meals, and other things I should watch out for.

			Afterwards, we commuted back to the LRT. Binondo is so weird because it's such a big and famous place in the heart of Manila city but it has some of the worst signal reception. While walking to the LRT, I passed by a girl who I thought looked like Belle. I took note of her appearance and continued walking. We got to the LRT and the ride was really cramped. I was so scared to have my phone taken from me so I tried hard to grip it. We eventually got off the train at EDSA station. Since we just wanted to get home quickly, I booked a Grab ride for us both to go to my house. I also paid the money I owed to Exavier and sent pics of our trip today. After that, I walked back to my house and Exavier walked to his house nearby.

			In the evening, I was browsing Instagram and eventually saw Belle's IG Story.

			### SHE WAS ALSO IN BINONDO TODAY.

			When I talked to her and told her that the girl I passed by was wearing a brown sleeveless shirt, she confirmed that she had worn that outfit earlier. I honestly couldn't believe it. **I passed by Belle on a random day, at a random time, at a random place in Manila**. It seriously made my brain explode. What are the odds? Belle and I had never met before, but apparently our first-time "meeting" was passing each other by as strangers at a street in Binondo. I don't even go to Binondo that much, if at all. This seriously shocked me and I kept talking to Belle about it. I also told Exavier as well. But after that, my night eventually wrapped up and I went to sleep.
		`,
	},
	{
		status: "average",
		spotify: {
			song: "Pasensya Ka Na",
			album: "Langit. Luha.",
			artist: "Silent Sanctuary",
			link: "https://open.spotify.com/track/4yrphG2212kF0aIt3qOt3g?si=7e651623008c4628"
		},
	},
	{
		status: "above-average",
		reason: `
			Today felt pretty productive for me. I got a lot of things done at work and in my personal life, and I felt better from that. I migrated from a Globe physical SIM to an eSIM and, after work, I went to SM Aura then Market! Market! to convert my Smart number to an eSIM as well. After that, I ate at Paotsin and ordered the shark's fin dumpling there, which was pretty nice. I went home early and my evening was pretty chill after that.
		`,
		spotify: {
			artist: "Lord Huron",
			album: "Strange Trails",
			song: "The Night We Met",
			link: "https://open.spotify.com/track/3hRV0jL3vUpRrcy398teAU?si=b4e6d69a1b1a491c"
		},
	},
	{
		status: "average",
		reason: `
			Nothing much happened today aside from me getting the replacement SIM for my old number, but nothing ever came out of it. It didn't really activate and I just wasted money on a replacement SIM.
		`,
		spotify: {
			song: "Rather Be (feat. Jess Glynne)",
			album: "Rather Be (feat. Jess Glynne)",
			artist: "Clean Bandit",
			link: "https://open.spotify.com/track/3s4U7OHV7gnj42VV72eSZ6?si=ba93f44724694c60"
		},
	},
	{
		status: "above-average",
		title: "You're Green!",
		icon: "book_5",
		reason: `
			Today seemed like a pretty average day, but in the morning I got the first half of my 13th month pay and I was able to breathe easy from that. I paid off some credit card bills early and I was able to buy Royal Canin food for Milktea again. I also bought healthy food for myself, which was pretty pricey but I thought was worth it. I was also mostly bored in the afternoon and commented on a post on Reddit about posting wallets and I posted mine. After a while, it got hundreds of upvotes.

			After work ended, since I had nothing to do for the evening, I just went outside to watch Wicked (2024) at Venice Grand Plaza. Thankfully, I got a ticket and I was early enough to have some spare time. I shopped around Miniso buying Cinnamoroll items for myself and I bought something for my sister as well. When I got in, I had to inform the lady that I sat next to that I bought the seat next to her. It was a bit awkward to then see that my seat had no popcorn and drinks allotted, but thankfully I'm an extrovert and I simply went outside the theater and called an attendant to give me the popcorn and drink that came with my ticket.

			I then watched the movie and it was pretty good. I went in mostly blind and I didn't even know that it was about the Wizard of Oz, but I really, really liked the film. Especially the ending which sort of resonated with me a bit. After the movie ended, I went home and talked to my sister for a bit. I eventually slept afterward.
		`,
		spotify: {
			song: "Defying Gravity",
			album: "Wicked: The Soundtrack",
			artist: "Cynthia Erivo, Ariana Grande",
			link: "https://open.spotify.com/track/5QMrH5nszZZR3nefIj6Mar?si=7ad65c945b1e40e4"
		},
		resonatedLyrics: [
			"And if I'm flying solo",
			"At least, I'm flying free",
			"To those who'd ground me",
			"Take a message back from me",
			"",
			"Tell them how I'm defying gravity",
			"I'm flying high, defying gravity",
			"And soon, I'll match them in renown",
		]
	},
	{
		status: "average",
		spotify: {
			artist: "Passion Pit",
			album: "Kindred",
			song: "All I Want",
			link: "https://open.spotify.com/track/4QaeQX43q3OdWE4JQxomF8?si=f029c1c9c2f947b8"
		}
	},
	{
		status: "above-average",
		reason: `
			Things were like your typical day today, I did my tasks, and work passed by just fine. In the morning, I received the battery replacement for my OnePlus phone. I told my sister that I was going to go to Market! Market! to have it repaired and she wanted me to also have her Samsung phone repaired.
			
			In the afternoon and after timing out for work, I booked a ride to Market! Market! to have the phone repaired. Thankfully, I had both phones repaired easily and in a quick manner. It also didn't cost me much to have both repaired, only for 800 Pesos. I tried to find a replacement screen protector for my phone that didn't have a black border, but I couldn't find one. I just tried to get a lens cover for my iPhone and that was it. I went home afterward.

			My evening was pretty chill with nothing much going on.
		`,
	},
	{
		status: "above-average",
		icon: "sms",
		title: "Messages from the Past",
		reason: `
			Since today was boring, I decided to do something. I restored all of my old messages from my Nokia phone from 2012 and I had to reset my iPhone just so I could transfer some messages. I also moved some messages from my Samsung Note 20 Ultra to my phone. It was a painful process and it took a big chunk of my time, but I had nothing better to do anyway so I just focused on it.

			In the evening, I got to play Valorant with Rachel and I got to show her that I went bald. We joined the server of Rachel's friends and I got to FaceTime her and show her that I was bald. She couldn't believe it at first and laughed a bit, but I owned up to it and told her the reason.

			After that, we played Valorant to pass the night and shared stories with each other. I told her what I was still feeling and that I still missed that person, and she tried her best to console me. I also asked her how she was doing and what she plans to do next year when she stays in Manila. We played a few rounds until it was our last one and we ended with a win, which was nice. Our gameplay ended there and I tried to sleep for the night, but couldn't.
		`,
		spotify: {
			artist: "Bruno Major",
			song: "Regent's Park",
			link: "https://open.spotify.com/track/2qiDXgq5fL1FetkhX5xi9L?si=66ba7e955b4f4b82",
			album: "To Let A Good Thing Die"
		}
	},
	{
		status: "above-average",
		icon: "book",
		title: "Wicked with my sister",
		reason: `
			I was bored and couldn't sleep so I went to some chat app and matched with someone new. I met someone named Naomi and we eventually started talking. I went to rest after talking to them.

			Today was a pretty boring Sunday until my sister came up to me and hung around my room. She was singing Popular all day and I wanted to take her to watch Wicked (2024) so she could see the movie as well. I originally planned it for next week, but since I had nothing else planned, I just immediately booked tickets for 4:20 in the afternoon. The tickets were pretty pricey at 1,400 for both of us, but it was worth it because my sister helps me out a lot.

			I just passed time in the afternoon and we eventually had to prepare to leave at around 3 p.m. She booked an Angkas first and I eventually got a ride as well after a while. We watched at my favorite movie theater, the Venice Cineplex Ultra Cinema, at Venice Grand Canal Mall. I was scared that we would be late but we actually arrived just in time. We watched the movie and I can tell that my sister was moved by it. The people who sat to the right of us, though, were talking the whole time during the movie. They were so loud and one even tried to sing while a quiet scene was playing, which was annoying. We kept shushing at them and they eventually had quieted out at the end. In the end, my sister was in tears and I already knew that she loved the movie as much as I did.

			After watching, ate at Marugame Udon nearby. My sister wanted to read the book and we were supposed to visit the Fully Booked nearby. After eating, we tried to look for the Fully Booked nearby. We stopped by a store that sells Apple accessories and stuff so I could get my tempered glass replaced. It took a while and my sister got tired while waiting outside the store. I'm glad I was able to replace my screen protector, though. The screen looks so much better now. We kept walking and eventually found out that the Fully Booked store had closed. Since we were both kind of tired, we just went home and my night has been pretty chill.
		`,
	},
	{
		status: "average",
		reason: `
			Nothing much went on today, but in the afternoon while playing Sky, I was able to get the Moomin plushie for someone's account. I'm glad that I was able to be dedicated enough to do the dailies every day without having someone by my side anymore. And now I finally collected the Moomin plushie for their account. It's a hollow win because I'm not with someone anymore to celebrate it with.

			Also, Naomi wanted to go to a rage room with me so I have that to look forward to for December, which is nice.
		`,
		spotify: {
			song: "Uptown Girl",
			artist: "Billy Joel",
			link: "https://open.spotify.com/track/5zA8vzDGqPl2AzZkEYQGKh?si=10dbe9e60cd74856",
			album: "An Innocent Man"
		},
	},
	{
		status: "average",
		spotify: {
			song: "Bakit Papa?",
			artist: "Sexbomb Girls",
			link: "https://open.spotify.com/track/3sHPFj12oEx79RLIHJVy55?si=bf393a41f358441c",
			album: "Unang Putok"
		},
	},
	{
		status: "average",
		spotify: {
			song: "IDGAF",
			artist: "Dua Lipa",
			link: "https://open.spotify.com/track/76cy1WJvNGJTj78UqeA5zr?si=809f3a17e07e42bd",
			album: "Dua Lipa (Deluxe)"
		},
		resonatedLyrics: [
			"You say you're sorry, but it's too late now",
			"So save it, get gone, shut up",
			"'Cause if you think I care about you now",
			"Well, boy, I don't give a fuck",
		]
	},
	{
		status: "above-average",
		icon: "video_camera_front",
		title: "A New Look",
		reason: `
			Today was pretty alright. Work was pretty chill and I was able to handle my tasks well. We also got our salary today so I was able to donate 1,500 Pesos to a person who fosters cats.

			In the afternoon, Reynald sent me the completed commission for my OC. Apparently, he had already completed it last month and was waiting on me, meanwhile, I was waiting for Reynald. It was a funny situation, but I was able to update the profile pictures on my alter account. It was really nice to see a new artwork for my OC, and Rey's drawing looked pretty professional.
		`,
		spotify: {
			song: "Smart",
			artist: "LE SSERAFIM",
			link: "https://open.spotify.com/track/4lR8sYGMGZPvthF2yUfo7T?si=1d932e5045b5406d",
			album: "Smart (Remixes)"
		},
	},
	{
		status: "above-average",
		reason: `
			Work today was pretty chill, there were some stressful bits but it was nothing I couldn't handle. Also, Tiffany sent her *pasalubong* from her trip to Cebu, which was pretty nice. Work eventually ended and my evening was pretty chill. I also ordered BOK Chicken for my sister and me because it was Friday. We had some conflict regarding rice but we were still able to eat the chicken while it was relatively hot. I also got to talk to Tiffany about a lot of things, which was pretty fun. I also showed her some pics of her that I found in some of my Google Photos albums. Also, Naomi invited me to watch a movie online with her since it was the weekend.

			For the RC, I decided to just invite the other people and I also pulled in Reilly. Tiffany was confirmed to go on specific dates so I wanted the others to come with and tag along. Hopefully, our trip in December pushes through because I miss hanging out with friends.

			I just chilled until 10 and that's when Naomi and I got into Discord and watched About Time (2013) together. It's nice to always share my favorite movie with other people. It's cute that she called my voice sweet and I found it funny that she was shy, but by the end of the movie she eventually opened up and we talked about a few things. The night continued from there.
		`,
		spotify: {
			artist: "Paramore",
			song: "crushcrushcrush",
			link: "https://open.spotify.com/track/4m9NfjevXsDVaLtM1kj0Sx?si=80f34741068b4438",
			album: "Riot!"
		}
	},
	{
		status: "above-average",
		reason: `
			Today seemed like a boring Saturday so I went out to BGC to complete my mood calendar entries. I hung out at my usual place, at Starbucks 32nd Street, and I just relaxed there and continued writing my entries. I also did OT work, which was a first in a while. I completed writing the bulk of my entries and I closed my laptop to go out and eat. I thought about that language to learn and I was leaning on learning French for next year, for my future travels in Europe. When I went outside, it was drizzling a bit and I had to make a decision on whether or not I would eat outside or go home and order takeout again. Since my sister wasn't home yet, I just decided to eat outside. I settled on Ramen Nagi and I chose the Black King Ramen as my dish. I eventually arrived at One Bonifacio High Street and ate my ramen while watching some downloaded videos from YouTube.

			It was a bit annoying how poor the signal reception was there. I tried to use my pocket Wi-Fi connection and even my iPhone, and both just couldn't get a proper signal. I honestly couldn't believe it because I'm in the middle of BGC, a very well-known place, and yet the signal here is as horrible as in a remote village. But whatever, I just watched the downloaded videos I had and paid for my meal. Afterward, I talked to Naomi and she says that she's interested in continuing a mood calendar of her own. She even read my blog posts because she was bored. It was nice to know and we kept talking once I got home and the night continued from there.
		`,
		spotify: {
			song: "Defying Gravity",
			album: "Wicked: The Soundtrack",
			artist: "Cynthia Erivo, Ariana Grande",
			link: "https://open.spotify.com/track/5QMrH5nszZZR3nefIj6Mar?si=7ad65c945b1e40e4"
		},
		resonatedLyrics: [
			"It's me",
			"",
			"So if you care to find me",
			"Look to the western sky",
			"As someone told me lately",
			"\"Everyone deserves the chance to fly\"",
			"And if I'm flying solo",
			"At least, I'm flying free",
			"To those who'd ground me",
			"Take a message back from me",
			"",
			"Tell them how I'm defying gravity",
			"I'm flying high, defying gravity",
			"And soon, I'll match them in renown",
		]
	},
];

export default novemberMap;
